import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, OnChanges, SimpleChanges, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { ModalClickOutsideService } from '../../services/modal-click-outside.service';

export interface ModalConfig {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  confirmButtonClass?: string;
  icon?: string;
  iconColor?: string;
  warningMessage?: string;
  disabled?: boolean;
  isLoading?: boolean;
}

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.css']
})
export class ConfirmationModalComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {
  @Input() isVisible = false;
  @Input() config: ModalConfig = {
    title: 'Confirmation',
    message: 'Êtes-vous sûr de vouloir effectuer cette action ?',
    confirmText: 'Confirmer',
    cancelText: 'Annuler',
    confirmButtonClass: 'modal-btn-primary',
    icon: 'warning',
    iconColor: 'blue'
  };
  
  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();

  @ViewChild('modalContent', { static: false }) modalContent!: ElementRef;

  constructor(private modalClickOutsideService: ModalClickOutsideService) {}

  ngOnInit(): void {
    // Le modal sera enregistré dans ngAfterViewInit quand modalContent sera disponible
  }

  ngAfterViewInit(): void {
    this.updateModalRegistration();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isVisible'] && this.modalContent) {
      // Attendre que le DOM soit mis à jour avant d'enregistrer le modal
      setTimeout(() => {
        this.updateModalRegistration();
      }, 0);
    }
  }

  private updateModalRegistration(): void {
    if (!this.modalContent) return;
    
    if (this.isVisible) {
      this.modalClickOutsideService.registerModal(this.modalContent, () => this.onClose());
    } else {
      this.modalClickOutsideService.unregisterModal(this.modalContent);
    }
  }

  ngOnDestroy(): void {
    if (this.modalContent) {
      this.modalClickOutsideService.unregisterModal(this.modalContent);
    }
  }

  getIconClass(): string {
    const colors: any = { red: 'bg-red-100 text-red-600', blue: 'bg-blue-100 text-blue-600', yellow: 'bg-yellow-100 text-yellow-600', green: 'bg-green-100 text-green-600' };
    return colors[this.config.iconColor || 'blue'] || colors.blue;
  }

  onConfirm() { 
    if (!this.config.disabled && !this.config.isLoading) {
      this.config.isLoading = true;
      this.confirm.emit(); 
    }
  }
  onCancel() { 
    if (!this.config.isLoading) {
      this.cancel.emit(); 
      this.close.emit(); 
    }
  }
  onClose() { 
    if (!this.config.isLoading) {
      this.close.emit(); 
    }
  }
  stopPropagation(e: Event) { e.stopPropagation(); }
}
